/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicAssetFilterNotificationRuleAssetScopeConditionDto } from './PublicAssetFilterNotificationRuleAssetScopeConditionDto';
import type { PublicDataProductFilterNotificationRuleAssetScopeConditionDto } from './PublicDataProductFilterNotificationRuleAssetScopeConditionDto';
import type { PublicNotificationRuleAssetScopeDto } from './PublicNotificationRuleAssetScopeDto';
import type { PublicSourceFilterNotificationRuleAssetScopeConditionDto } from './PublicSourceFilterNotificationRuleAssetScopeConditionDto';
import type { PublicTagFilterNotificationRuleAssetScopeConditionDto } from './PublicTagFilterNotificationRuleAssetScopeConditionDto';

export type PublicDynamicNotificationRuleAssetScopeDto = (PublicNotificationRuleAssetScopeDto & {
    /**
     * List of the conditions defining asset scope of the notification rule
     */
    conditions?: Array<(PublicAssetFilterNotificationRuleAssetScopeConditionDto | PublicDataProductFilterNotificationRuleAssetScopeConditionDto | PublicSourceFilterNotificationRuleAssetScopeConditionDto | PublicTagFilterNotificationRuleAssetScopeConditionDto)>;
    /**
     * Logical operator to use between conditions
     */
    filterLogicalOperator?: PublicDynamicNotificationRuleAssetScopeDto.filterLogicalOperator;
} & {
    /**
     * List of the conditions defining asset scope of the notification rule
     */
    conditions: Array<(PublicAssetFilterNotificationRuleAssetScopeConditionDto | PublicDataProductFilterNotificationRuleAssetScopeConditionDto | PublicSourceFilterNotificationRuleAssetScopeConditionDto | PublicTagFilterNotificationRuleAssetScopeConditionDto)>;
    /**
     * Logical operator to use between conditions
     */
    filterLogicalOperator: PublicDynamicNotificationRuleAssetScopeDto.filterLogicalOperator;
});

export namespace PublicDynamicNotificationRuleAssetScopeDto {

    /**
     * Logical operator to use between conditions
     */
    export enum filterLogicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
